module.exports = __webpack_public_path__ + "static/media/brown-house-near-pine-trees-covered-with-snow-754268.08b935a6.jpg";